<template>
	<div>
		<carousel />
	</div>
</template>

<script>
	import Carousel from '@/components/Carousel';

	export default {
		components: {
			Carousel,
		},
	};
</script>